import { createContext } from 'react';
import { ClientAccountListHostProps } from './types';

export const ClientAccountListContext = createContext<ClientAccountListHostProps | null>(null);
